<template>
  <div class="d-flex flex-wrap w-100">
    <v-text-field
      :model-value="familyName"
      label="姓"
      density="compact"
      hide-details
      data-test="doctorFamilyName-field"
      v-bind="sharedAttrs"
      min-width="200px"
      @update:model-value="$emit('update:family-name', $event)"
    />
    <v-text-field
      :model-value="firstName"
      label="名"
      density="compact"
      hide-details
      data-test="doctorFirstName-field"
      v-bind="sharedAttrs"
      min-width="200px"      
      @update:model-value="$emit('update:first-name', $event)"
    />
  </div>
</template>

<script>
/**
 * 回答者氏名（姓・名）入力フィールド（FSD shared/ui）
 *
 * familyName / firstName を props として受け取り、
 * update:family-name / update:first-name を emit する。
 *
 * 使用例:
 *   <DoctorNameInput
 *     :family-name="doctorFamilyName"
 *     :first-name="doctorFirstName"
 *     @update:family-name="doctorFamilyName = $event"
 *     @update:first-name="doctorFirstName = $event"
 *   />
 */
export default {
  name: "DoctorNameInput",

  props: {
    familyName: {
      type: String,
      default: ""
    },
    firstName: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /** v-text-field に追加で渡す attrs（variant, style など） */
    fieldAttrs: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ["update:family-name", "update:first-name"],

  computed: {
    sharedAttrs() {
      return {
        disabled: this.disabled,
        ...this.fieldAttrs
      };
    }
  }
};
</script>
